import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const criteres = [
  { title: 'crit_1_h3', desc: 'crit_1_p', icon: 'ri-shield-check-line' },
  { title: 'crit_2_h3', desc: 'crit_2_p', icon: 'ri-award-line' },
  { title: 'crit_3_h3', desc: 'crit_3_p', icon: 'ri-shield-star-line' },
  { title: 'crit_4_h3', desc: 'crit_4_p', icon: 'ri-user-follow-line' },
  { title: 'crit_5_h3', desc: 'crit_5_p', icon: 'ri-star-line' },
  { title: 'crit_6_h3', desc: 'crit_6_p', icon: 'ri-file-shield-line' },
  { title: 'crit_7_h3', desc: 'crit_7_p', icon: 'ri-list-check-2' },
  { title: 'crit_8_h3', desc: 'crit_8_p', icon: 'ri-team-line' },
  { title: 'crit_9_h3', desc: 'crit_9_p', icon: 'ri-map-pin-line' },
  { title: 'crit_10_h3', desc: 'crit_10_p', icon: 'ri-vip-crown-line' },
];

export default function Les10Criteres() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="criteres" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('criteres_h2')}
      </h2>

      <div className="space-y-6">
        {criteres.map((crit, idx) => (
          <div
            key={idx}
            className={`flex gap-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 80 + 150}ms` }}
          >
            <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-copper/10">
              <i className={`${crit.icon} text-copper`} />
            </div>
            <div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-1.5">
                {t(crit.title)}
              </h3>
              <p className="text-slate-primary/60 text-sm leading-relaxed">{t(crit.desc)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}